// URL はフォームの action から組み立てるため、コレクションと検索のどちらでも動作する。
// 検索で使うときは hidden の q / options[prefix] をフォームに含めること
class CedarwoodCollection extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.debounceTimer = null;
    this.controller = null;
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onInput = this.onInput.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onPopState = this.onPopState.bind(this);
    this.renderedPath = window.location.pathname + window.location.search;
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.addEventListener('change', this.onChange);
    this.addEventListener('input', this.onInput);
    this.addEventListener('submit', this.onSubmit);
    window.addEventListener('popstate', this.onPopState);
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.onPopState);
  }

  get dialog() {
    return this.querySelector('[data-filter-dialog]');
  }

  get form() {
    return this.querySelector('[data-filter-form]');
  }

  onClick(e) {
    if (this.dialog && e.target === this.dialog) {
      this.dialog.close();
      return;
    }
    if (e.target.closest('[data-filter-open]')) {
      if (this.dialog && this.dialog.showModal) this.dialog.showModal();
      return;
    }
    if (e.target.closest('[data-filter-close]')) {
      if (this.dialog) this.dialog.close();
      return;
    }
    const clearEl = e.target.closest('[data-filter-clear]');
    if (clearEl) {
      e.preventDefault();
      this.form.querySelectorAll('input[type="checkbox"]').forEach(function (i) {
        i.checked = false;
      });
      this.form.querySelectorAll('input[type="number"]').forEach(function (i) {
        i.value = '';
      });
      this.applyFilters();
      return;
    }
    const pageLink = e.target.closest('.pagination a');
    if (pageLink) {
      e.preventDefault();
      this.renderFromUrl(pageLink.href);
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  onChange(e) {
    if (!e.target.closest('[data-filter-form]')) return;
    if (e.target.type === 'number') return;
    this.applyFilters();
  }

  onInput(e) {
    if (!e.target.closest('[data-filter-form]')) return;
    if (e.target.type !== 'number') return;
    clearTimeout(this.debounceTimer);
    const self = this;
    this.debounceTimer = setTimeout(function () {
      self.applyFilters();
    }, 500);
  }

  onSubmit(e) {
    e.preventDefault();
    this.applyFilters();
  }

  onPopState() {
    // ハッシュだけの移動でも popstate が発生するため、一覧の URL が変わったときだけ描き直す
    if (window.location.pathname + window.location.search === this.renderedPath) return;
    // 戻る・進むでは履歴を積まず、フォームの選択状態も URL に合わせる
    this.renderFromUrl(window.location.href, { fromHistory: true });
  }

  buildUrl() {
    const base = this.form.getAttribute('action') || window.location.pathname;
    const data = new FormData(this.form);
    const params = new URLSearchParams();
    for (const pair of data.entries()) {
      if (pair[1] !== '') params.append(pair[0], pair[1]);
    }
    const qs = params.toString();
    if (qs) return base + '?' + qs;
    return base;
  }

  applyFilters() {
    this.renderFromUrl(this.buildUrl());
  }

  renderFromUrl(url, options) {
    const fromHistory = Boolean(options && options.fromHistory);
    // 連続操作時は前のfetchを中断（古い応答での上書き・無駄なフェッチを防ぐ）
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    this.setAttribute('aria-busy', 'true');
    const sep = url.indexOf('?') > -1 ? '&' : '?';
    const self = this;
    fetch(url + sep + 'section_id=' + this.sectionId, { signal: this.controller.signal })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const swap = function (selector) {
          const next = doc.querySelector(selector);
          const current = self.querySelector(selector);
          if (next && current) current.innerHTML = next.innerHTML;
        };
        swap('[data-collection-results]');
        swap('[data-filter-open]');
        swap('[data-result-count]');
        if (fromHistory) swap('[data-filter-form]');
        const title = doc.querySelector('[data-page-title]');
        if (title && title.textContent.trim()) document.title = title.textContent.replace(/\s+/g, ' ').trim();
        const next = new URL(url, window.location.href);
        self.renderedPath = next.pathname + next.search;
        // ページ移動・絞り込みを戻るで 1 操作ずつ遡れるよう履歴に積む（#401）
        if (!fromHistory && self.renderedPath !== window.location.pathname + window.location.search) {
          window.history.pushState({}, '', url);
        }
        self.removeAttribute('aria-busy');
      })
      .catch(function (err) {
        // 中断(AbortError)は後続fetchが処理を継続するため busy 状態を保持
        if (!err || err.name !== 'AbortError') self.removeAttribute('aria-busy');
      });
  }
}

if (!customElements.get('cedarwood-collection')) {
  customElements.define('cedarwood-collection', CedarwoodCollection);
}
